import groupPlugin from './group-plugin';

export default groupPlugin;
